import { Vue, Component, Prop } from 'vue-property-decorator';
import Table from '@/components/table/table.vue';
import PropsTableCellBody from './subcomponents/props-table-cell-body/props-table-cell-body.vue';
import PropsTableCellHeader from './subcomponents/props-table-cell-header/props-table-cell-header.vue';
import { TableData, TableCellInfo, TableRowObject, TableDataKeys } from 'components';
import { processData } from './helper-methods';

@Component({
	components: {
		's-table': Table
	},

	beforeCreate() {
		const components: { [index: string]: object } = {
			'props-table-cell-body': PropsTableCellBody,
			'props-table-cell-head': PropsTableCellHeader
		};

		Object.keys(components).forEach((componentName: string) => {
			Vue.component(componentName, components[componentName]);
		});
	},

	mounted() {
		if (this.$props.data) {
			const processedData: TableData = {};
			const dataToProcess = {
				...this.$props.data,
				cols: PropsTable.tableHeaders
			};

			Object.keys(dataToProcess).forEach((key) => {
				processedData[<TableDataKeys>key] = processData(dataToProcess[key], key, PropsTable.tableHeaders.data.length);
			});

			this.tableData = {
				...processedData,
				cellSizes: ['cell_s', 'cell_s', 'cell_s', 'cell_header']
			};
		}
	}
})
export default class PropsTable extends Vue {
	@Prop()
	data?: TableData;

	tableData: TableData = {
		cols: <Array<TableCellInfo>>[],
		rows: <Array<Array<TableCellInfo> | TableRowObject>>[],
		cellSizes: <Array<string>>[]
	};

	isTableVisible: boolean = true;

	toggleTable() {
		this.isTableVisible = !this.isTableVisible;
	}

	static tableHeaders: {
		data: Array<string>;
	} = {
		data: ['nazwa właściwości', 'typ', 'wartość domyślna', 'opis']
	};
}
